export const TYPE = {
  SET_DATA_TIME: 'SET_DATA_TIME',
  SET_SHOW_CONTAINER_RECORDING_BAR: 'SET_SHOW_CONTAINER_RECORDING_BAR',
};
